import { createIcon } from '@chakra-ui/react';

export const Login = createIcon({
  displayName: 'Login',
  viewBox: '0 0 24 24',
  path: (
    <path
      id="Sign_In_-_L-2"
      data-name="Sign In - L"
      d="M23.955,11.936H5.437l5.055-5.059a.564.564,0,0,0-.8-.8L3.673,12.119a.564.564,0,0,0,0,.8L9.7,18.938a.564.564,0,0,0,.8-.8L5.433,13.063H23.955a.571.571,0,0,0,0-1.143ZM12.526,14.351a.564.564,0,0,0-.564.564v8.457H1.708V1.627H11.955v8.457a.571.571,0,0,0,1.143,0V1.071A.564.564,0,0,0,12.519.5H1.144a.564.564,0,0,0-.564.571V23.928a.564.564,0,0,0,.564.571H12.519a.564.564,0,0,0,.564-.571V14.915a.564.564,0,0,0-.564-.564Z"
      transform="translate(-0.58 -0.499)"
      fill="currentColor"
    />
  ),
});
